export default [
    {
      name: "关于我们", path: "",
      children:[
        {name: "翠麟简介", path: "/about/shisw"},
        {name: "翠麟团队", path: "/about/team"},
        {name: "翠麟荣誉", path: "/cuilinhonor"},
        {name: "合作伙伴", path: "/about/partner"},
        {name: "联系我们", path: "/about/contact"},
      ]
    },
    {
      name: "短片竞赛", path: "",
      children:[
        {name: "翠麟短片奖", path: "/competition/short"},
        {name: "翠麟剧本奖", path: "/competition/scenario"},
        {name: "海派新浪潮", path: "/competition/haipai"},
        {name: "AI创意影像", path: "/competition/AICreativeImaging"},
        //{name: "获奖名单", path: "/competition/winner"},
        // {name: "报名方式", path: "/competition/apply"},
        {name: "获奖作品", path: "/winnerList/history"},
      ]
    },
    {
      name: "短片展映", path: "",
      children:[
        {name: "翠麟短片角", path: "/news/index?categoryId=5193486210528881618"},
        // {name: "翠麟点映", path: "/showing/site/index"},
        // {name: "翠麟云剧场", path: "/movie/index"},
        // {name: "点播平台", path: "/vod/index"}
      ]
    },
    {
      name: "新闻中心", path: "",
      children:[
        {name: "最新动态", path: "/news/index?categoryId=5381694687660911745"},
        {name: "采访", path: "/news/index?categoryId=4946536439816158038"},
        {name: "影评", path: "/news/index?categoryId=5248568026432460307"}
      ]
    },
    {
      name: "翠麟计划", path: "",
      children:[
        {name: "项目扶持", path: "/plan/index"},
        {name: "国际宣发", path: "/preview/index"},
        {name: "创作训练", path: "/creation/index"},
        {name: "翠麟出品", path: "/plan/league"}
      ]
    },
    // {
    //   name: "翠麟社区", path: "",
    //   children:[
    //     // {name: "关于社区", path: "/about/cuilin"},
    //     // {name: "翠麟精英", path: "/talent/index"},
    //     // {name: "特约摄影师", path: "/photographer"},
    //     {name: "创作训练营", path: "/creation/index"},
    //     // {name: "项目众筹", path: "/crowd/index"},
        
    //     {name: "版权代理", path: "/preview/index"},
    //     {name: "投奖策略", path: "/strategy/index"},
    //     // {name: "增值服务", path: "/null"},
    //   ]
    // },
    {
      // name: "个人中心", path: "/user/index",
    }
    // { name: "翠麟社区", path: "/about/cuilin", index: "0" },
    // { name: "国际影展", path: "/competition/winner", index: "1" },
    // { name: "创作训练营", path: "/Learn", index: "2" },
    // { name: "服务中心", path: "/Datum", index: "5" },
    // { name: "创作者调研", path: "/Survey", index: "7" },
    // { name: "发现项目", path: "/crowdfunding/list", index: "8" },
    // { name: "展映基地", path: "/event/list", index: "9" },
    // { name: "关于SHISW", path: "/", index: "10" },
  ]